
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import First from '../../components/Ranking/First.vue'
import Second from '../../components/Ranking/Second.vue'
import Third from '../../components/Ranking/Third.vue'
import Fourth from '../../components/Ranking/Fourth.vue'
import Fifth from '../../components/Ranking/Fifth.vue'
import Sixth from '../../components/Ranking/Sixth.vue'
import Seventh from '../../components/Ranking/Seventh.vue'


@Component({
  name: 'role',
  components: { First, Second, Third, Fourth, Fifth, Sixth, Seventh }

})
export default class extends Vue {
  list: any = []

  campus: string = ''
  teacher: any = ''
  campusList: any = []
  teacherList: any = []
  time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
  activeName: string = 'first'
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  start_time: string = (Date.parse(<any>this.time[0]) / 1000).toString()
  end_time: string = (Date.parse(<any>this.time[1]) / 1000).toString()
  is_select: boolean = false


  mounted() {
    this.getSchool()
    this.getAllTeacher()
  }
  async getSchool() {
    const res: any = await UserModule.getCampus({ types: 'campus', org_id: this.org_id })
    if (res.code === 200 && res.data.list) {
      this.campusList = res.data.list
    }
  }
  async getAllTeacher() {
     const res: any = await CourseModule.getAllTeacher({ is_all: 1 })
     if(res.code === 200) {
       this.teacherList = res.data.list
     }
  }

  teacherChange(val) {
    this.teacher = val
    this.is_select = true
  }
  campusChange(val) {
    this.campus = val
    this.is_select = true
  } 
  changeTime(val) {
    const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
    this.time = [val[0], end]
    if (this.time) {
      this.start_time = (Date.parse(<any>this.time[0]) / 1000).toString()
      this.end_time = (Date.parse(<any>this.time[1]) / 1000).toString()
    } else {
      this.start_time = ''
      this.end_time = ''
    }
    this.is_select = true
  }
  handleClick(val) {
    this.is_select = true
    this.activeName = val.name
  }
  upData() {
    this.is_select = false
  }

}
